import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { user, logout } = useAuth();
  const location = useLocation();

  const disabled = (process.env.REACT_APP_MENU_DISABLED || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  const navLinks = [
    { to: '/payments', label: 'Payments' },
    { to: '/payroll', label: 'Payroll' },
    { to: '/jobs', label: 'Jobs' },
    { to: '/settings', label: 'Settings' },
  ].filter((link) => !disabled.includes(link.label));

  return (
    <div className="min-h-screen bg-[#f5f5f4] flex flex-col">
      <header className="bg-white border-b border-border/60 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <span className="text-sm font-semibold tracking-tight text-foreground">
              AnotherSnusFactory
            </span>
            <nav className="flex items-center gap-1">
              {navLinks.map((link) => {
                const active = location.pathname === link.to;
                return (
                  <Link
                    key={link.to}
                    to={link.to}
                    className={`px-3 py-1.5 rounded-md text-sm transition-colors ${
                      active
                        ? 'bg-foreground text-background font-medium'
                        : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                    }`}
                  >
                    {link.label}
                  </Link>
                );
              })}
            </nav>
          </div>

          <div className="flex items-center gap-4">
            <span className="text-xs text-muted-foreground">{user?.email}</span>
            <button
              onClick={logout}
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-7xl w-full mx-auto px-6 py-8">
        {children}
      </main>
    </div>
  );
}
